import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagEmploiFormation = () => {
  return (
    <LbaItemTag color="darkBlue" iconImageUri="/images/tableau.svg">
      EMPLOI + FORMATION
    </LbaItemTag>
  )
}
